import { FC, ReactNode, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import WizardNotification from "../../../components/notifications/wizard-notification";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { getCountsCategory, NOTIFICATION_TYPE_CATEGORY, TYPE_PER_PRESET_TYPE } from "../../../constants/system-constants";
import NotificationsTab from "../../../containers/notifications-tab";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Button } from "../../../components/button/Button";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import SystemStat from "../../../models/SystemStat";
import { getSystemStats } from "../../../services/systemService";
import { showError } from "../../../services/utilities/ServiceError";
import { useTabCount } from "@/hooks/useCategoryTab";
import { getListOfSiteIdsFromFilter } from "@/utilities/tabUtils";
import { Filter } from "@/models/Filter";

const Notifications: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();
    const [showModal, setShowModal] = useState(false);
    const { updateTabCount } = useTabCount({
        tableName: "VRule",
        categories,
        setCategories,
    });

    useEffect(() => {
        buildCategoriesData();
    }, []);

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            const showTabCounts = window.sessionStorage.getItem("showTabCounts") === "1";
            const systemStat: SystemStat | undefined = showTabCounts ? await getSystemStats(TYPE_PER_PRESET_TYPE) : undefined;
            
            setCategories([{
                displayName: translate.byKey(TranslationKeys.email),
                heading: translate.byKey(TranslationKeys.notifications),
                value: "",
                id: 0,
                count: systemStat ? getCountsCategory(systemStat, NOTIFICATION_TYPE_CATEGORY.ALL_NOTIFICATIONS) : 0,
            }]);

            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }
    }

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <NotificationsTab
                    setBusy={setBusy}
                    categories={categories}
                    setCategories={setCategories}
                    onFilterChange={onFilterChange}
                    setShowModal={setShowModal}
                />
            ];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const onModalClose = () => {
        setShowModal(false)
        buildCategoriesData();
    }

    const onFilterChange = (filters: Filter[]) => {
        const siteIds = getListOfSiteIdsFromFilter(filters);
        updateTabCount(siteIds)
    };

    return (
        <>
            <ActivityFrame busy={busy} className="flex flex-grow overflow-y-hidden">
                <div id="container-tabs" className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[
                            { value: '/access-control/notifications', displayName: translate.byKey(TranslationKeys.notifications), disableClick: true },
                            { value: "/access-control/notifications", displayName: translate.byKey(TranslationKeys.notifications) }]}
                        onClick={(item) => history.push(item.value)}>
                    </Breadcrumb>
                    <Tabs
                        className="bg-white"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        selected={selected}
                        onAdd={() => { }}
                        add={false}>
                        {tabContent[selected]}
                        <div className="flex flex-row justify-end button-cluster">
                            <Restricted to={`add.logins.element`}>
                                <Link to={{}}>
                                    <Button
                                        variant="submit"
                                        shape="rounded"
                                        id='notificationAdddButton'
                                        onClick={() => { setShowModal(true) }}
                                    >
                                        <img src={plusIcon} className="px-2 w-8 py-1" alt="" />
                                        <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                                    </Button>
                                </Link>
                            </Restricted>
                        </div>
                    </Tabs>
                </div>
                <WizardNotification onClose={onModalClose} isOpen={showModal} />
            </ActivityFrame>
        </>
    );
};

export default Notifications;
